import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from './self';

const clientsErrorSelector = createSelector(selfSelector, (clients) => clients.error);

export default clientsErrorSelector;
